import type { SetlistWs } from '@/types/session';
import { formatSongKey } from '@/utils/songKey';

interface Props {
  setlist: SetlistWs;
  currentSongId: string | null;
  currentIndex: number | null;
  isLeader: boolean;
  onSelectSong: (songId: string, index: number) => void;
  theme: any;
}

export default function SetlistSidebar({ setlist, currentSongId, currentIndex, isLeader, onSelectSong, theme }: Props) {
  return (
    <div className="flex flex-col">
      <div className="px-5 py-2.5 border-b flex items-center gap-2" style={{ borderBottomColor: theme.colors.border }}>
        <i className="ri-list-check-2 text-xs shrink-0" style={{ color: theme.colors.text.tertiary }}></i>
        <p className="text-xs font-semibold truncate" style={{ color: theme.colors.accent }}>{setlist.name}</p>
      </div>
      {setlist.items.length === 0 ? (
        <p className="text-xs text-center px-5 py-4" style={{ color: theme.colors.text.tertiary }}>Setlist vazio.</p>
      ) : (
        setlist.items.map((item, idx) => {
          const isActive = item.song_id === currentSongId || idx === currentIndex;
          return (
            <button
              key={item.id}
              onClick={() => isLeader && onSelectSong(item.song_id, idx)}
              disabled={!isLeader}
              className="flex items-center gap-3 px-5 py-2.5 text-left transition-colors w-full"
              style={{
                backgroundColor: isActive ? `${theme.colors.accent}15` : 'transparent',
                cursor: isLeader ? 'pointer' : 'default',
              }}
            >
              <span className="text-xs w-4 text-right shrink-0" style={{ color: theme.colors.text.tertiary }}>{idx + 1}</span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium truncate" style={{ color: isActive ? theme.colors.accent : theme.colors.text.secondary }}>
                  {item.song_title}
                </p>
                <p className="text-xs truncate" style={{ color: theme.colors.text.tertiary }}>
                  {item.song_artist}{item.song_key ? ` · ${formatSongKey(item.song_key, item.song_mode)}` : ''}
                </p>
              </div>
              {isActive && <span className="w-1.5 h-1.5 rounded-full shrink-0" style={{ backgroundColor: theme.colors.accent }}></span>}
            </button>
          );
        })
      )}
    </div>
  );
}
